export default {
  production: '64e30f3d53d2b17a15365343',
  development: '67851ced25fb5cb3c0f00c8e',
};
